export enum PolicyFieldModificationImpact {
  MonoContract = 1,
  MultiContract = 2,
  UserChoice = 3,
}
